<template>
    <div class="row page">
        <div class="form-account form-sign-in">
            <div class="form-account__welcome" v-if="hasUsername">
                <i class="fas fa-hand-paper"></i>
                <h5>Welcome {{getUsername}}</h5>
            </div>
            <h1>Sign in</h1>
            <div v-if="newAccount" class="col-12 alert alert-success" role="alert">
                Your account has been created. Please sign in to continue.
            </div>
            <form>
                <ul>
                    <li>
                        <label for="email">Email address</label>
                        <input id="email" type="text" v-model="username" class="form-account__email">
                    </li>
                    <li>
                        <label for="password">Password</label>
                        <input id="password" type="password" v-model="password" class="form-account__password">
                    </li>
                </ul>
                <div v-if="error" class="alert alert-danger" role="alert">
                    {{error}}
                </div>
                <button class="btn btn-primary" v-on:click.prevent="signIn()">Sign in</button>
                <div class="form-account__alt-action"><router-link to="/create-account">Create an account</router-link></div>
                <div class="form-account__alt-action"><router-link to="/forgot-password">Forgot password?</router-link></div>
            </form>
        </div>
    </div>
</template>

<script>
    import { store, mutations, getters } from '@/store.js'

    import * as Sentry from "@sentry/vue";

    export default {
        name: "SignIn.vue",
        data: function () {
            return {
                newAccount: false,
                username: store.host.email,
                password: "",
                error: null
            }
        },
        computed: {
            hasUsername: function () {
                if (store.host !== undefined && store.host.name !== undefined) {
                    return true;
                }
                return false
            },
            getUsername: function () {
                if (this.hasUsername) {
                    return store.host.name
                }
                return ''
            }
        },
        methods: {
            signIn: function () {
                this.error = null
                const config = {};
                if (getters.isAuthenticated()) {
                    console.log("Authenticated, including credentials")
                } else {
                    console.log("NOT Authenticated, including username + password")
                    config.auth = {
                        username: this.username,
                        password: this.password
                    }
                }
                console.log(config)
                this.$http.get('/guest-management/v1/user',
                    config
                ).then(response => {
                    console.log("Authentication response from server: ")
                    console.log(response)
                    if (response.data.reference) {
                        console.log("Authenticated")
                        mutations.setAuthenticated(true)
                        const user = response.data
                        mutations.setHost(user)
                        console.log(user);
                        if (user.state !== "active") {
                            // this.$root.$emit('signed-in', false)
                            this.$router.push({name: 'CreateAccount'})
                        } else  if (user.establishments.length === 0) {
                            this.$root.$emit('signed-in', false)
                            this.$router.push({name: 'ListEstablishments'})
                        } else {
                            mutations.setCurrentEstablishmentReference(user.establishments[0].reference)
                            this.$root.$emit('signed-in', true)
                            this.$router.push({name: 'TaskCalendar'})
                        }
                    }
                }).catch(error => {
                    mutations.signOut()
                    if (error.response) {
                        if (error.response.status === 401) {
                            this.error = "Incorrect username or password. Please try again."
                        } else {
                            this.error = error.response.data.message
                        }
                    } else {
                        this.error = "Sorry, we can't seem to reach our servers! Please try again"
                    }
                    Sentry.captureException(error);
                })
            }
        },
        mounted() {
            if (this.$route.query.created) {
                this.newAccount = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/sign-in";
</style>